import React, { useCallback } from "react";

import useInViewport from "src/organization/pages/project/environment/metrics/components/ViewPortOnly/useInViewport";
import useGroupPoller from "src/organization/pages/project/environment/metrics/utils/polling/useGroupPoller";
import { usePollgroupContext } from "src/organization/pages/project/environment/metrics/utils/polling/usePollgroup";
import useObservabilityPipelineHttpClient from "src/organization/pages/project/environment/observabilitySandbox/hooks/useObservabilityPipelineHttpClient";

import TotalUsage from "./TotalUsage2";
import UsageViewSkeleton from "./UsageViewSkeleton";

const pollerId = "total-resources-poller";

const UsageView = () => {
  const { visible } = useInViewport();

  const { pollgroup } = usePollgroupContext();
  const client = useObservabilityPipelineHttpClient();
  const requestFn = useCallback(
    t => client?.getResourcesOverview(t)!,
    [client]
  );

  const pollImmediate = visible && !!client;
  const { data, status } = useGroupPoller({
    pollerId,
    requestFn,
    pollgroup,
    pollImmediate
  });

  return status.refresh ? (
    <UsageViewSkeleton />
  ) : (
    <TotalUsage data={data?.data || []} />
  );
};

export default UsageView;
